export default __webpack_public_path__ + "static/media/srinagar2.8e9f89c5.jpg";